import {
  UPDATE_COLUMN_CONFIG_REQUEST,
    updateColumnConfigSuccess,
    updateColumnConfigFailure,
} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';


export function updateColumnConfigEpic(action$, store$, { TableRepository }) {
  return action$.pipe(
    ofType(UPDATE_COLUMN_CONFIG_REQUEST),
    mergeMap( action => from(TableRepository.updateColumnConfig( action.payload.tableEntryId, action.payload.columnConfig ))
      .pipe(
        mergeMap( tableEntry => {
          return from ([
            updateColumnConfigSuccess(tableEntry),
          ]);
        }),
        catchError( error => {
          return from([
            updateColumnConfigFailure(error),
          ])
        })
      )
    ),
  );
}
